import * as React from 'react';
import { useBrand } from 'shared/hooks/useBrand';

export const Silhouette = () => {
  const brand = useBrand();
  return <img src={`/assets/${brand}/components/add-vehicle/vehicle.svg`} />;
};
